import { useState, useEffect } from 'react';
import { navItems, siteInfo } from '@/mocks/homepage';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[64px] md:h-[72px]">
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
            className="flex items-center gap-2 group cursor-pointer"
          >
            <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-fire-line text-background-50 text-lg md:text-xl"></i>
            </span>
            <span className="text-lg md:text-xl font-bold text-foreground-900 whitespace-nowrap">
              {siteInfo.name}
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#app"
              onClick={(e) => { e.preventDefault(); handleNavClick('#app'); }}
              className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line"></i>
              <span>下载 App</span>
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors duration-200 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#app"
              onClick={(e) => { e.preventDefault(); handleNavClick('#app'); }}
              className="flex items-center justify-center gap-1.5 px-4 py-2.5 mt-2 text-sm font-medium bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-download-line"></i>
              <span>下载 App</span>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}